/**
 *
 * Component: ProductTourNavigation
 * Date: 30/8/2021
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';

import styles from './style.css';
const { SubMenu } = Menu;

function ProductTourNavigation({
  tourGuidesOptions,
  selectedKeys,
  setSelectedKeys,
  defaultOpenKeys,
  onTitleClick,
}) {
  return (
    <div className={styles.container}>
      <Menu
        data-testid="menu-cy"
        style={{ width: 256 }}
        mode="inline"
        theme="light"
        onSelect={e => {
          setSelectedKeys(...e.selectedKeys);
        }}
        openKeys={[defaultOpenKeys]}
        selectedKeys={selectedKeys}
      >
        {tourGuidesOptions.map(submenu => (
          <SubMenu
            onTitleClick={onTitleClick}
            key={submenu.id}
            title={
              <div
                className={`${submenu.date ? styles.submenuContainer : ''} ${
                  submenu.id === defaultOpenKeys ? styles.selectedSubMenu : ''
                } `}
              >
                <span className={styles.submenuTitle}>{submenu.title}</span>
                {submenu.date && (
                  <span className={styles.submenuDate}>{submenu.date}</span>
                )}
              </div>
            }
          >
            {submenu.subOptions.map(option =>
              option?.id && option?.title ? (
                <Menu.Item key={option.id}>{option.title}</Menu.Item>
              ) : (
                <></>
              ),
            )}
          </SubMenu>
        ))}
      </Menu>
    </div>
  );
}

ProductTourNavigation.propTypes = {
  tourGuidesOptions: PropTypes.array,
  selectedKeys: PropTypes.number,
  setSelectedKeys: PropTypes.func,
  defaultOpenKeys: PropTypes.array,
  onTitleClick: PropTypes.func,
};

export default ProductTourNavigation;
